module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_tractus_calendar-small-50c25fc37f3c4ffb9e05bfe61615321f.png";